import {VehicleForm as VFKit} from '../VehicleForm';

export function CountryOfOriginGroup() {
  return (
    <>
      <VFKit.OriginCountrySelect />
      <VFKit.FirstRegistrationCountrySelect />
      <VFKit.LastRegistrationCountrySelect />
    </>
  );
}
